<template>
  <v-layout>
    <v-btn @click="onClick" flat color="#004884" class="text-none pr-4">
      <v-icon>arrow_back</v-icon>
      {{'BUTT_NAV_BACK' | translate}}
    </v-btn>
  </v-layout>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'BtnBack',
    components: {},
    methods: {
      onClick: function () {
        // window.history.back()
        // console.log('window.location', window.location.href)
        Vue.prototype.$eventHub.$emit('OnBackButtonClick', window.location.href)
        if ((window.location.href.indexOf('StructureDataDetailed') > -1) || (window.location.href.indexOf('StructureDataAnchor') > -1)) {
          window.history.go(-2)
        } else {
          window.history.go(-1)
        }

      }
    },
    data() {
      return {}
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/BtnBack.vue